import React from 'react';
import Login from '../../components/Login';

const AuthGuard = ({ user, onLogin, children }) => {
  if (!user) {
    return <Login onLogin={onLogin} />;
  }

  return children;
};

export default AuthGuard;